// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
rem,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
rembed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  line-height: normal;
  color: #000;
}

ul,
ol,
li,
dl,
dt,
dd {
  list-style: none;
}

address,
em,
var,
i {
  font-style: normal;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
  word-break: normal;
  box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -webkit-text-size-adjust: none;
}

header {
  width: 100%;
  border-bottom: 1px solid #ededed;
  float: left;
  height: 80px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

#int_ft {
  background: #333333;
  height: 143px;
  width: 100%;
  float: left;
  color: #C5C5C5;
  display: flex;
  font-size: 1.2rem;
  align-items: center;
}

html,
body,
button,
a {
  font-family: "Noto Sans KR", "Nanum Gothic", "나눔 고딕", "Malgun Gothic", "돋움", "sans-serif";
}

html,
body {
  font-size: 10px;
  color: #000;
  line-height: 1.4rem;
  box-sizing: border-box;
  letter-spacing: -0.024rrem;
  width: 100%;
  height: 100%;
}

body {
  font-size: 1.6rem;
  font-weight: 400;
}

img {
  image-rendering: -webkit-optimize-contrast;
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-perspective: 1;
}

img,
input,
select,
button,
textarea {
  vertical-align: middle;
  box-sizing: border-box;
}

img,
fieldset,
iframe {
  border: 0;
}

button {
  display: inline-block;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  vertical-align: middle;
  overflow: visible;
  background: transparent;
  outline: none;
}

button,
button:hover {
  font-family: inherit;
}

a,
button {
  color: #000;
}

a {
  color: inherit;
  text-decoration: none;
}

.btn_xl {
  padding: 0 50px !important;
  height: 65px !important;
  font-size: 20px !important;
  line-height: 65px !important;
}

.btn {
  font-size: 12px;
  padding: 5px 10px;
  min-height: 18px;
  border-radius: 3px;
  height: 26px;
  box-sizing: border-box;
}

.btn {
  font-size: 0.12px;
  width: auto;
  height: 33px;
  line-height: 30px;
  margin: 0 3px;
  padding: 0 10px;
  border-radius: 3px;
  box-sizing: border-box;
}

span,
i {
  display: inline-block;
}

::-webkit-scrollbar-thumb {
  height: 50px;
  width: 50px;
  background: rgba(25, 25, 25, 0.3);
  border-radius: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:root {
  --fc-list-event-dot-width: 10px;
  --fc-list-event-hover-bg-color: #f5f5f5;
  --fc-daygrid-event-dot-width: 8px;
}

input[type=text], input[type=password], input[type=number], input[type=email], textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  border: 1px solid #e0e0e0;
}

input[type=text] {
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 8px 10px;
}

input[type=password] {
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 8px 10px;
}

input[type=radio], input[type=checkbox] {
  margin: 4px 0 0;
  margin-top: 1px \\9 ;
  line-height: normal;
}

.bold {
  font-weight: bold !important;
}

.ft_logo {
  float: left;
  margin-right: 20px;
}

.f_list {
  width: calc(100% - 150px);
}
.f_list .f_link {
  width: auto;
  margin-right: 15px;
  font-size: 1.4rem;
}
.f_list li {
  width: 100%;
  float: left;
  padding: 10px 0 0 0;
}

.center_wrap,
.help_wrap,
.notice_wrap {
  width: calc(100% - 260px);
  float: left;
  max-height: calc(100% - 80px);
  overflow: auto;
  padding: 40px;
  position: relative;
}
.center_wrap h2,
.help_wrap h2,
.notice_wrap h2 {
  width: 100%;
  font-weight: 600;
}

.mb30 {
  margin-bottom: 3rem !important;
}

.w100 {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/core.css","webpack://./src/styles/core.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;ADEF;;ACCA;;;;;;;;;;;EAWE,cAAA;ADEF;;ACCA;;;;;;EAME,mBAAA;EACA,WAAA;ADEF;;ACCA;;;;;;EAME,gBAAA;ADEF;;ACCA;;;;EAIE,kBAAA;ADEF;;ACCA;;;EAIE,sBAAA;ADEF;;ACCA;EACE,SAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;ADEF;;ACCA;EACE,WAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;ADEF;;ACEA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;ADCF;;ACEA;;;;EAIE,yFAAA;ADCF;;ACEA;;EAEE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;ADCF;;ACEA;EACE,iBAAA;EACA,gBAAA;ADCF;;ACEA;EACE,0CAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;ADCF;;ACEA;;;;;EAKE,sBAAA;EACA,sBAAA;ADCF;;ACEA;;;EAGE,SAAA;ADCF;;ACEA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;ADCF;;ACEA;;EAEE,oBAAA;ADCF;;ACEA;;EAEE,WAAA;ADCF;;ACEA;EACE,cAAA;EACA,qBAAA;ADCF;;ACEA;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;ADCF;;ACEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;ADCF;;ACEA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;ADCF;;ACEA;;EAEE,qBAAA;ADCF;;ACEA;EACE,YAAA;EACA,WAAA;EACA,iCAAA;EAEA,kBAAA;ADCF;;ACEA;EACE,uBAAA;ADCF;;ACEA;EACE,UAAA;EACA,WAAA;ADCF;;ACEA;EACE,+BAAA;EACA,uCAAA;EACA,iCAAA;ADCF;;ACKA;EACE,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,aAAA;EACA,yBAAA;ADFF;;ACOA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;ADJF;;ACOA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;ADJF;;ACOA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,WAAA;EACA,kBAAA;ADJF;;ACOA;EACE,yBAAA;ADJF;ACME;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;ADJJ;ACOE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;ADLJ;;ACSA;;;EAGE,yBAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;ADNF;ACQE;;;EACE,WAAA;EACA,gBAAA;ADJJ;;ACQA;EACE,8BAAA;ADLF;;ACQA;EACE,sBAAA;ADLF","sourcesContent":["@charset \"UTF-8\";\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nrem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nrembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  vertical-align: baseline;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  line-height: normal;\n  color: #000;\n}\n\nul,\nol,\nli,\ndl,\ndt,\ndd {\n  list-style: none;\n}\n\naddress,\nem,\nvar,\ni {\n  font-style: normal;\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  word-break: normal;\n  box-sizing: border-box;\n  -o-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  -webkit-text-size-adjust: none;\n}\n\nheader {\n  width: 100%;\n  border-bottom: 1px solid #ededed;\n  float: left;\n  height: 80px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n#int_ft {\n  background: #333333;\n  height: 143px;\n  width: 100%;\n  float: left;\n  color: #C5C5C5;\n  display: flex;\n  font-size: 1.2rem;\n  align-items: center;\n}\n\nhtml,\nbody,\nbutton,\na {\n  font-family: \"Noto Sans KR\", \"Nanum Gothic\", \"나눔 고딕\", \"Malgun Gothic\", \"돋움\", \"sans-serif\";\n}\n\nhtml,\nbody {\n  font-size: 10px;\n  color: #000;\n  line-height: 1.4rem;\n  box-sizing: border-box;\n  letter-spacing: -0.024rrem;\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  font-size: 1.6rem;\n  font-weight: 400;\n}\n\nimg {\n  image-rendering: -webkit-optimize-contrast;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n  -webkit-perspective: 1;\n}\n\nimg,\ninput,\nselect,\nbutton,\ntextarea {\n  vertical-align: middle;\n  box-sizing: border-box;\n}\n\nimg,\nfieldset,\niframe {\n  border: 0;\n}\n\nbutton {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  cursor: pointer;\n  vertical-align: middle;\n  overflow: visible;\n  background: transparent;\n  outline: none;\n}\n\nbutton,\nbutton:hover {\n  font-family: inherit;\n}\n\na,\nbutton {\n  color: #000;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n.btn_xl {\n  padding: 0 50px !important;\n  height: 65px !important;\n  font-size: 20px !important;\n  line-height: 65px !important;\n}\n\n.btn {\n  font-size: 12px;\n  padding: 5px 10px;\n  min-height: 18px;\n  border-radius: 3px;\n  height: 26px;\n  box-sizing: border-box;\n}\n\n.btn {\n  font-size: 0.12px;\n  width: auto;\n  height: 33px;\n  line-height: 30px;\n  margin: 0 3px;\n  padding: 0 10px;\n  border-radius: 3px;\n  box-sizing: border-box;\n}\n\nspan,\ni {\n  display: inline-block;\n}\n\n::-webkit-scrollbar-thumb {\n  height: 50px;\n  width: 50px;\n  background: rgba(25, 25, 25, 0.3);\n  border-radius: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n:root {\n  --fc-list-event-dot-width: 10px;\n  --fc-list-event-hover-bg-color: #f5f5f5;\n  --fc-daygrid-event-dot-width: 8px;\n}\n\ninput[type=text], input[type=password], input[type=number], input[type=email], textarea {\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  outline: none;\n  border: 1px solid #e0e0e0;\n}\n\ninput[type=text] {\n  border: 1px solid #e0e0e0;\n  border-radius: 3px;\n  padding: 8px 10px;\n}\n\ninput[type=password] {\n  border: 1px solid #e0e0e0;\n  border-radius: 3px;\n  padding: 8px 10px;\n}\n\ninput[type=radio], input[type=checkbox] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9 ;\n  line-height: normal;\n}\n\n.bold {\n  font-weight: bold !important;\n}\n\n.ft_logo {\n  float: left;\n  margin-right: 20px;\n}\n\n.f_list {\n  width: calc(100% - 150px);\n}\n.f_list .f_link {\n  width: auto;\n  margin-right: 15px;\n  font-size: 1.4rem;\n}\n.f_list li {\n  width: 100%;\n  float: left;\n  padding: 10px 0 0 0;\n}\n\n.center_wrap,\n.help_wrap,\n.notice_wrap {\n  width: calc(100% - 260px);\n  float: left;\n  max-height: calc(100% - 80px);\n  overflow: auto;\n  padding: 40px;\n  position: relative;\n}\n.center_wrap h2,\n.help_wrap h2,\n.notice_wrap h2 {\n  width: 100%;\n  font-weight: 600;\n}\n\n.mb30 {\n  margin-bottom: 3rem !important;\n}\n\n.w100 {\n  width: 100% !important;\n}/*# sourceMappingURL=core.css.map */","html,\r\nbody,\r\ndiv,\r\nspan,\r\napplet,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\na,\r\nabbr,\r\nacronym,\r\naddress,\r\nbig,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nrem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\ns,\r\nsamp,\r\nsmall,\r\nstrike,\r\nstrong,\r\nsub,\r\nsup,\r\ntt,\r\nvar,\r\nb,\r\nu,\r\ni,\r\ncenter,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nrembed,\r\nfigure,\r\nfigcaption,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\noutput,\r\nruby,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 0;\r\n  vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection {\r\n  display: block;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  line-height: normal;\r\n  color: #000;\r\n}\r\n\r\nul,\r\nol,\r\nli,\r\ndl,\r\ndt,\r\ndd {\r\n  list-style: none;\r\n}\r\n\r\naddress,\r\nem,\r\nvar,\r\ni {\r\n  font-style: normal;\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  word-break: normal;\r\n  box-sizing: border-box;\r\n  -o-box-sizing: border-box;\r\n  -ms-box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n  -webkit-box-sizing: border-box;\r\n  -webkit-text-size-adjust: none;\r\n}\r\n\r\nheader {\r\n  width: 100%;\r\n  border-bottom: 1px solid #ededed;\r\n  float: left;\r\n  height: 80px;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n\r\n}\r\n\r\n#int_ft {\r\n  background: #333333;\r\n  height: 143px;\r\n  width: 100%;\r\n  float: left;\r\n  color: #C5C5C5;\r\n  display: flex;\r\n  font-size: 1.2rem;\r\n  align-items: center;\r\n}\r\n\r\nhtml,\r\nbody,\r\nbutton,\r\na {\r\n  font-family: \"Noto Sans KR\", 'Nanum Gothic', '나눔 고딕', 'Malgun Gothic', '돋움', 'sans-serif';\r\n}\r\n\r\nhtml,\r\nbody {\r\n  font-size: 10px;\r\n  color: #000;\r\n  line-height: 1.4rem;\r\n  box-sizing: border-box;\r\n  letter-spacing: -0.024rrem;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\nbody {\r\n  font-size: 1.6rem;\r\n  font-weight: 400;\r\n}\r\n\r\nimg {\r\n  image-rendering: -webkit-optimize-contrast;\r\n  transform: translateZ(0);\r\n  backface-visibility: hidden;\r\n  -webkit-perspective: 1;\r\n}\r\n\r\nimg,\r\ninput,\r\nselect,\r\nbutton,\r\ntextarea {\r\n  vertical-align: middle;\r\n  box-sizing: border-box;\r\n}\r\n\r\nimg,\r\nfieldset,\r\niframe {\r\n  border: 0;\r\n}\r\n\r\nbutton {\r\n  display: inline-block;\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n  overflow: visible;\r\n  background: transparent;\r\n  outline: none;\r\n}\r\n\r\nbutton,\r\nbutton:hover {\r\n  font-family: inherit;\r\n}\r\n\r\na,\r\nbutton {\r\n  color: #000;\r\n}\r\n\r\na {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\n.btn_xl {\r\n  padding: 0 50px !important;\r\n  height: 65px !important;\r\n  font-size: 20px !important;\r\n  line-height: 65px !important;\r\n}\r\n\r\n.btn {\r\n  font-size: 12px;\r\n  padding: 5px 10px;\r\n  min-height: 18px;\r\n  border-radius: 3px;\r\n  height: 26px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.btn {\r\n  font-size: .12px;\r\n  width: auto;\r\n  height: 33px;\r\n  line-height: 30px;\r\n  margin: 0 3px;\r\n  padding: 0 10px;\r\n  border-radius: 3px;\r\n  box-sizing: border-box;\r\n}\r\n\r\nspan,\r\ni {\r\n  display: inline-block;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  height: 50px;\r\n  width: 50px;\r\n  background: rgba(25, 25, 25, 0.3);\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n:root {\r\n  --fc-list-event-dot-width: 10px;\r\n  --fc-list-event-hover-bg-color: #f5f5f5;\r\n  --fc-daygrid-event-dot-width: 8px;\r\n}\r\n\r\n// focus style\r\n$input-selector: \"input[type=text], input[type=password], input[type=number], input[type=email], textarea\";\r\n\r\n#{$input-selector} {\r\n  -webkit-transition: all 0.30s ease-in-out;\r\n  -moz-transition: all 0.30s ease-in-out;\r\n  -ms-transition: all 0.30s ease-in-out;\r\n  -o-transition: all 0.30s ease-in-out;\r\n  outline: none;\r\n  border: 1px solid #e0e0e0; // 기본 테두리 색상\r\n\r\n\r\n}\r\n\r\ninput[type=\"text\"] {\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 3px;\r\n  padding: 8px 10px;\r\n}\r\n\r\ninput[type=\"password\"] {\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 3px;\r\n  padding: 8px 10px;\r\n}\r\n\r\ninput[type=\"radio\"], input[type=\"checkbox\"] {\r\n  margin: 4px 0 0;\r\n  margin-top: 1px \\9;\r\n  line-height: normal;\r\n}\r\n\r\n.bold {\r\n  font-weight: bold !important;\r\n}\r\n\r\n.ft_logo {\r\n  float: left;\r\n  margin-right: 20px;\r\n}\r\n\r\n.f_list {\r\n  width: calc(100% - 150px);\r\n\r\n  .f_link {\r\n    width: auto;\r\n    margin-right: 15px;\r\n    font-size: 1.4rem;\r\n  }\r\n\r\n  li {\r\n    width: 100%;\r\n    float: left;\r\n    padding: 10px 0 0 0;\r\n  }\r\n}\r\n\r\n.center_wrap,\r\n.help_wrap,\r\n.notice_wrap {\r\n  width: calc(100% - 260px);\r\n  float: left;\r\n  max-height: calc(100% - 80px);\r\n  overflow: auto;\r\n  padding: 40px;\r\n  position: relative;\r\n\r\n  h2 {\r\n    width: 100%;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.mb30 {\r\n  margin-bottom: 3rem !important;\r\n}\r\n\r\n.w100 {\r\n  width: 100% !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
